import React from 'react';
import clsx from 'clsx';

interface EmptyValueProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const EmptyValue: React.FC<EmptyValueProps> = ({ 
  className, 
  size = 'md' 
}) => {
  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-2xl'
  };

  return (
    <span className={clsx('text-rm-neutral-400 font-medium', sizeClasses[size], className)}>
      --
    </span>
  );
};

export default EmptyValue;